var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"mailto:contact@instapaylink.com"}},[_vm._v("contact@instapaylink.com")])}
var staticRenderFns = []

export { render, staticRenderFns }